import { createFileRoute, Outlet } from "@tanstack/react-router";

import { SetupShell } from "@/components/layouts/SetupShell";

export const Route = createFileRoute("/app/$role/setup")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SetupShell>
      <Outlet />
    </SetupShell>
  );
}
